import { CommonModule } from '@angular/common';
import { Component, inject, signal, ViewContainerRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule, NzModalService } from 'ng-zorro-antd/modal';
import { NzTableModule, NzTableQueryParams } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import {
  NhfAccessRowItemSearchResult,
  NhfLoginType,
  NhfSystemType,
} from '../../../../core/api/mhsIdentityApiClient';
import { NfzBranchLookup } from '../../../../core/context/nhf-branch-lookup';
import { NfzService } from '../../services/nfz-service';
import { EwusKolcePasswordChange } from '../ewus-kolce-password-change/ewus-kolce-password-change';

@Component({
  selector: 'app-ewus-kolce-view',
  imports: [
    CommonModule,
    NzTableModule,
    NzFlexModule,
    NzIconModule,
    CommonModule,
    FormsModule,
    NzTableModule,
    NzInputModule,
    NzButtonModule,
    NzIconModule,
    NzFlexModule,
    NzDropdownModule,
    NzTagModule,
    NzModalModule,
  ],
  templateUrl: './ewus-kolce-view.html',
  styleUrl: './ewus-kolce-view.scss',
})
export class EwusKolceViewComponent {
  readonly nfzService = inject(NfzService);
  readonly searchResult = signal<NhfAccessRowItemSearchResult | null>(null);
  readonly loading = signal(true);
  readonly systemTypeLabels = NhfSystemType;
  readonly loginTypeLabels = NhfLoginType;
  readonly viewContainerRef = inject(ViewContainerRef);
  readonly messageService = inject(NzModalService);
  readonly nfzBranchCodes = [{ code: '', name: 'Brak' }, ...NfzBranchLookup.branches];
  total = 0;
  pageSize = 10;
  pageIndex = 1;

  toLoginTypeLabel(loginType: NhfLoginType): string {
    return loginType === NhfLoginType.ServiceProvider ? 'Świadczeniodawca' : 'Lekarz';
  }

  toSystemTypeLabel(systemType: NhfSystemType): string {
    return this.systemTypeLabels[systemType] ?? systemType;
  }
  changePasswordClick(accountId: number): void {
    this.changePasswordClickModal(accountId);
  }
  changePasswordClickModal(id: number): void {
    const modal = this.messageService.create<EwusKolcePasswordChange, number>({
      nzTitle: 'Zmień hasło użytkownika',
      nzContent: EwusKolcePasswordChange,
      nzViewContainerRef: this.viewContainerRef,
      nzData: id,
      nzFooter: null,
    });
  }
  onQueryParamsChange(params: NzTableQueryParams): void {
    const sort = params.sort.find((item) => item.value !== null);
    this.pageIndex = params.pageIndex;
    this.pageSize = params.pageSize;
    this.loading.set(true);

    this.nfzService
      .searchNhfAccess(params.pageIndex, params.pageSize, sort?.key, sort?.value === 'ascend')
      .subscribe({
        next: (result) => {
          this.searchResult.set(result);
          this.total = result.total ?? 0;
          this.loading.set(false);
        },
        error: (error) => {
          console.error('Unable to load NHF access accounts.', error);
          this.loading.set(false);
        },
      });
  }
}
